import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { formatCallClock } from '@common/voice';
const KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'];
const STAGE_TEXT = {
    incoming: 'Incoming call',
    starting: 'Starting\u2026',
    connecting: 'Calling\u2026',
    ringing: 'Ringing\u2026',
    reconnecting: 'Reconnecting\u2026',
};
export function CallElapsed({ since }) {
    const [now, setNow] = useState(() => Date.now());
    useEffect(() => {
        const timer = window.setInterval(() => setNow(Date.now()), 1000);
        return () => window.clearInterval(timer);
    }, []);
    return _jsx(_Fragment, { children: formatCallClock((now - since) / 1000) });
}
export function CallStatus({ call, endedAt }) {
    if (endedAt !== null) {
        const talked = call.answeredAt === null ? null : formatCallClock((endedAt - call.answeredAt) / 1000);
        return _jsx(_Fragment, { children: talked === null ? 'Call ended' : `Call ended \u00b7 ${talked}` });
    }
    if (call.stage === 'open' && call.answeredAt !== null)
        return _jsx(CallElapsed, { since: call.answeredAt });
    if (call.stage === 'connecting' && call.direction === 'inbound')
        return _jsx(_Fragment, { children: "Connecting\u2026" });
    return _jsx(_Fragment, { children: STAGE_TEXT[call.stage === 'open' ? 'connecting' : call.stage] });
}
export function CallKeypad({ enabled, onSendDigits }) {
    const [pressed, setPressed] = useState('');
    return (_jsxs(Box, { children: [_jsx(Typography, { variant: "body2", color: "text.secondary", align: "center", sx: { minHeight: 20 }, "aria-label": "Keys pressed", children: pressed }), _jsx(Box, { sx: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 1, mt: 1 }, children: KEYS.map((key) => (_jsx(Button, { variant: "outlined", color: "inherit", "aria-label": `Key ${key}`, disabled: !enabled, sx: { minHeight: 44, fontSize: 18 }, onClick: () => {
                        onSendDigits(key);
                        setPressed((value) => `${value}${key}`.slice(-24));
                    }, children: key }, key))) })] }));
}
